import {
	Select, Spin, Modal, Form, Checkbox, Space, Divider
}from 'antd'
import {
	useEffect,
	useState
}from 'react'
import {
	useSelector, useDispatch
}from 'react-redux'
import {
	useDebounce
}from 'use-debounce'
import CustomButton from '../../components/CustomButton'
import CustomSelect from '../../components/CustomSelect'
import CustomAddButton from "../../components/CustomAddButton"
import {
	Scrollbars
}from "react-custom-scrollbars"
import {
	reOrgActions
}from '../NRI/ReOrgs/store/actions'
import './style.css'
import {
	rePriceFormationOrderActions
}from '../NRI/RePriceFormationOrder/store/actions'
import {
	reInfoOrgTypeActions
}from '../NRI/ReInfoOrgType/store/actions'
const { Option } = Select

const AddReInfoOrg = ({ visible, setVisible, pageSize, create, prices, types }) => {
	const [reOrg, setReOrg] = useState('')
	const [searchReOrg] = useDebounce(reOrg, 500)
	const { minOrg, isSending: minOrgSending } = useSelector(state => state.reOrgReducer)
	const { changed, isSending } = useSelector(state => state.reInfoOrgReducer)
	const [form] = Form.useForm()

	const dispatch = useDispatch()

	const getOrgs = (values) => {
		dispatch(reOrgActions.getMinOrgByNameOrUNP(values))
	}

	useEffect(() => {
		return () => {
			dispatch(reInfoOrgTypeActions.clear())
			dispatch(reOrgActions.clear())
			dispatch(rePriceFormationOrderActions.clear())
		}
	}, [])

	useEffect(() => {
		if (searchReOrg.length > 2){
			getOrgs({
				name     : searchReOrg,
				pageSize : pageSize
			})
		}
	}, [searchReOrg])

	useEffect(() => {
		if (changed)
			handleCancel()
	}, [changed])

	const handleCancel = () => {
		setVisible(false)
		form.resetFields()
	}

	function createReInfoOrgs(){
		form.validateFields().then(values => {
			if (values.form?.length)
				create({ orgs: values.form })
		})
	}

	return (
		<Modal
			className="orgs-add-modal"
			footer={ [
				<CustomButton
					key="submit"
					loading={ isSending }
					onClick={ () => createReInfoOrgs() }
				>
					Сохранить
				</CustomButton>
			] }
			title="Добавление организаций в перечень для представления данных в ИСС"
			visible={ visible }
			width={ 800 }
			onCancel={ handleCancel }
		>
			<Scrollbars
				autoHeight
				autoHide
				autoHeightMax={ 600 }
			>
				<Form
					labelWrap
					form={ form }
					labelCol={ {
						span: 7
				  } }
					name="reInfoOrgForm"
				>
					<Form.List name="form">
						{ (fields, { add, remove }) => (
							<>
								{ fields.map(({ key, name, ...restField }, index) => (
									<Space
										key={ key }
										align="baseline"
										className="space-form-add-reOrg-material"
										direction="vertical"
									>
										<Form.Item
											{ ...restField }
											label="Организация"
											name={ [name, 'reOrg'] }
											rules={ [
												{
													required : true,
													message  : "Пожалуйста, выберите организацию"
												}
											] }
										>
											<CustomSelect
												allowClear
												showSearch
												filterOption={ false }
												getPopupContainer={ trigger => trigger.parentNode }
												mode="single"
												notFoundContent={ minOrgSending && <Spin size="large" /> }
												placeholder="Введите название/УНП организации"
												onSearch={ (e) => setReOrg(e) }
											>
												{ minOrg?.map(item => {
													return (
														<Option
															key={ item.id }
															title={ item.name }
															value={ item.id }
														>
															{ item.name }
														</Option>)
												}) }
											</CustomSelect>
										</Form.Item>
										<Form.Item
											{ ...restField }
											label="Категория организации"
											name={ [name, 'type'] }
										>
											<CustomSelect
												allowClear
												showSearch
												getPopupContainer={ trigger => trigger.parentNode }
												mode="single"
												notFoundContent={ null }
												optionFilterProp="title"
												placeholder="Выберите категорию организации"
												style={ {
													width: '100%'
												} }
											>
												{ Boolean(types) && Array.isArray(types) && types?.map(type => {
													return (
														<Option
															key={ type.id }
															title={ type.name }
															value={ type.id }
														>
															{ type.name }
														</Option>)
												}) }
											</CustomSelect>
										</Form.Item>
										<Form.Item
											{ ...restField }
											label="Использование возможных регионов реализации"
											name={ [name, 'isUsePossibleRegion'] }
											valuePropName="checked"
										>
											<Checkbox />
										</Form.Item>
										<Form.Item
											{ ...restField }
											label="Порядок формирования цены"
											name={ [name, 'priceOrders'] }
											rules={ [
												{
													required : true,
													message  : "Пожалуйста, выберите порядок формирования цены"
												}
											] }
										>
											<CustomSelect
												allowClear
												showSearch
												getPopupContainer={ trigger => trigger.parentNode }
												mode="multiple"
												notFoundContent={ null }
												optionFilterProp="title"
												placeholder="Выберите порядки формирования цен"
												style={ {
													width: '100%'
												} }
											>
												{ Boolean(prices) && Array.isArray(prices) && prices?.map(price => {
													return (
														<Option
															key={ price.id }
															title={ price.name }
															value={ price.id }
														>
															{ price.name }
														</Option>)
												}) }
											</CustomSelect>
										</Form.Item>
										<CustomButton
											size="small"
											style={ { float: "right" } }
											type="grey"
											onClick={ () => remove(name) }
										>
											Удалить
										</CustomButton>
										<Divider plain />
									</Space>
								)) }
								<Form.Item>
									<CustomAddButton
										onClick={ () => add() }
									/>
								</Form.Item>
							</>
						) }
					</Form.List>
				</Form>
			</Scrollbars>
		</Modal>
	)
}

export default AddReInfoOrg